namespace Nobox.Web.Hubs {
    export interface UploadedFileCustom {
        Filename?: string;
        OriginalName?: string;
        FileSize?: string;
    }
}
